<template>
  <a-modal v-model="modal.visible" :title="modal.title" @cancel="handleCancel" @ok="handleOk">
    <render-dom :vnode="modal.content"></render-dom>
    <template v-slot:footer v-if="modal.type === 'info'">
      <a-button @click="handleOk" type="primary">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  data() {
    return {
      modal: {
        title: '',
        content: '',
        visible: false,
        type: '',
      },
    }
  },
  methods: {
    show(params) {
      this.modal.title = params.title
      this.modal.content = params.content
      this.modal.visible = true
      this.modal.type = params.type || 'default'
      return new Promise((resolve, reject) => {
        this.$once('end', function(state, result) {
          // info确认或者点x都是resolve
          if (this.modal.type === 'info') {
            resolve()
          }
          if (state === 'ok') {
            resolve(result)
          }
          if (state === 'cancel') {
            reject(new Error('E_CANCEL'))
          }
          this.modal.visible = false
        })
      })
    },
    async handleOk() {
      this.$emit('end', 'ok')
    },
    handleCancel() {
      this.$emit('end', 'cancel')
    },
  },
}
</script>

<style></style>
